import styled from "styled-components";

export const Wrapper = styled.div`
  > div {
    margin-bottom: 32px;
  }
`;
